'use strict';

export function slideUp(el, duration= 500) {
  el.style.transitionProperty = 'height, margin, padding';
  el.style.transitionDuration = duration + 'ms';
  el.style.boxSizing = 'border-box';
  el.style.height = el.offsetHeight + 'px';
  el.offsetHeight;
  el.style.overflow = 'hidden';
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  window.setTimeout( () => {
    el.style.display = 'none';
    el.style.removeProperty('height');
    el.style.removeProperty('padding-top');
    el.style.removeProperty('padding-bottom');
    el.style.removeProperty('margin-top');
    el.style.removeProperty('margin-bottom');
    el.style.removeProperty('overflow');
    el.style.removeProperty('transition-duration');
    el.style.removeProperty('transition-property');
  }, duration);
}

export function slideDown(el, duration= 500) {
  el.style.removeProperty('display');
  let display = window.getComputedStyle(el).display;

  if(display === 'none') {
    display = 'block';
  }

  el.style.display = display;
  let height = el.offsetHeight;
  el.style.overflow = 'hidden';
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  el.offsetHeight;
  el.style.boxSizing = 'border-box';
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + 'ms';
  el.style.height = height + 'px';
  el.style.removeProperty('padding-top');
  el.style.removeProperty('padding-bottom');
  el.style.removeProperty('margin-top');
  el.style.removeProperty('margin-bottom');
  window.setTimeout( () => {
    el.style.removeProperty('height');
    el.style.removeProperty('overflow');
    el.style.removeProperty('transition-duration');
    el.style.removeProperty('transition-property');
  }, duration);
}

export function slideToggle(el, duration = 500) {
  if (window.getComputedStyle(el).display === 'none') {
    return slideDown(el, duration);
  } else {
    return slideUp(el, duration);
  }
}

export function htmlSearch(data, container) {
  container.innerHTML = '';
  data.forEach((item) => {
    let li = document.createElement('li');
    li.className = 'search-form__item';
    li.innerHTML = `<a href="${item.url}" class="search-form__link">${item.title}</a>`;

    container.append(li);
  });
}

export function htmlBrands(data, btn, type) {
  data.forEach((item) => {
    let div = document.createElement('div');
    div.className = 'brand-card';
    let features = '';
    let featuresArray = ['min', 'wager'];
    let link = type === 'themes' ? '<button type="button" class="btn btn-secondary brand-card__link" disabled>Read review</button>' : `<a href="${item.url}" class="btn btn-secondary brand-card__link">Read review</a>`;
    let buttonRef = item.ref === '' ? `<button class="btn btn-primary brand-card__button${item.classes_ref}">Play now!</button>` : `<a href="${item.ref}" target="_blank" class="btn btn-primary brand-card__button${item.classes_ref}">Play now!</a>`;

    item.features.forEach((feat, index) => {
      features += `<p class="brand-card__item brand-card__features--${featuresArray[index]}">${feat.label}<span>${feat.value}</span></p>`;
    });

    div.innerHTML = `<div class="brand-card__picture" style="background-color: ${item.background_logo};">
      <picture>
        <source media="(min-width: 768px)" srcset="${item.img.desktop}">
        <img src="${item.img.mobile}" alt="${item.name}" width="280" height="96" class="brand-card__img">
      </picture>
    </div>
    <div class="brand-card__rank">
      <p class="brand-card__title">${item.name}</p>
      <p class="brand-card__rating rating" style="--percent: ${item.percent}%">${item.rating}</p>
      <p class="brand-card__description">${item.text}</p>
    </div>
    <div class="brand-card__bonus">
      <p class="brand-card__label">${item.label_bonus}</p>
      <p class="brand-card__text">${item.text_bonus}</p>
    </div>
    <div class="brand-card__features">${features}</div>
    <div class="brand-card__btns">
      ${buttonRef}
      ${link}
    </div>`;

    btn.before(div);
  });
}

export function htmlBrandsSlider(data, container, type) {
  data.forEach((item) => {
    let div = document.createElement('div');
    div.className = 'brand-card brand-card--slider splide__slide';
    let link = type === 'themes' ? '<button type="button" class="btn btn-secondary brand-card__link" disabled>Read review</button>' : `<a href="${item.url}" class="btn btn-secondary brand-card__link">Read review</a>`;
    let buttonRef = item.ref === '' ? `<button class="btn btn-primary brand-card__button${item.classes_ref}">Play now!</button>` : `<a href="${item.ref}" target="_blank" class="btn btn-primary brand-card__button${item.classes_ref}">Play now!</a>`;

    div.innerHTML = `<div class="brand-card__picture brand-card__picture--slider" style="background-color: ${item.background_logo};">
      <picture>
        <source media="(min-width: 768px)" srcset="${item.img.desktop}">
        <img src="${item.img.mobile}" alt="${item.name}" width="280" height="96" class="brand-card__img">
      </picture>
    </div>
    <div class="brand-card__rank brand-card__rank--slider">
      <p class="brand-card__title">${item.name}</p>
      <p class="brand-card__rating rating" style="--percent: ${item.percent}%">${item.rating}</p>
      <p class="brand-card__description">${item.text}</p>
    </div>
    <div class="brand-card__bonus brand-card__bonus--slider">
      <p class="brand-card__label">${item.label_bonus}</p>
      <p class="brand-card__text brand-card__text--slider">${item.text_bonus}</p>
    </div>
    <div class="brand-card__btns">
      ${buttonRef}
      ${link}
    </div>`;

    container.append(div);
  });
}

export function htmlNews(data, btn) {
  data.forEach((item) => {
    let div = document.createElement('div');
    div.className = 'news-card news-card--horizontal';

    div.innerHTML = `<a href="${item.url}" class="news-card__picture news-card__picture--horizontal">
      <picture>
        <source media="(min-width: 768px)" srcSet="${item.img.desktop}">
          <img src="${item.img.mobile}" alt="${item.title}" class="news-card__img news-card__img--horizontal" width="98" height="73">
      </picture>
    </a>
    <div class="news-card__content">
      <a href="${item.url}" class="news-card__title news-card__title--horizontal">${item.title}</a>
      <div class="information">
        <time class="information__date" dateTime="${item.date.datetime}">${item.date.visible}</time>
        <span class="information__views">${item.views}</span>
      </div>
    </div>`;

    btn.before(div);
  });
}

export function calcProgress(circle) {
  const percent = circle.getAttribute('data-percent');
  const radiusCircle = parseInt( window.getComputedStyle(circle, null).getPropertyValue('r') );
  const lengthCircle = Math.PI * radiusCircle * 2;
  return ( (100 - percent) / 100 ) * lengthCircle;
}